var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page content-container"},[_c('title-with-breadcrumbs',{attrs:{"title":_vm._f("capitalize")(_vm._f("translate")(_vm.translationSubNav))}}),_c('product-grid')],1)}
var staticRenderFns = []

export { render, staticRenderFns }